import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import CcEmailsInput from './CcEmailsInput';
import './EditNotificationsModal.css';

const FREQUENCY_OPTIONS = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'never', label: 'Never' }
];

const FREQUENCY_HINTS = {
    daily: "You'll receive a daily email with new matching properties.",
    weekly: "You'll receive a weekly digest every Monday.",
    monthly: "You'll receive a monthly digest on the 1st.",
    never: "You won't receive email notifications."
};

const EditNotificationsModal = ({ isOpen, box, onClose, onSave }) => {
    const [emailFrequency, setEmailFrequency] = useState('daily');
    const [ccEmails, setCcEmails] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (box) {
            setEmailFrequency(box.email_frequency || 'daily');
            setCcEmails(box.cc_emails || []);
        }
    }, [box]);

    if (!isOpen || !box) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        await onSave({ email_frequency: emailFrequency, cc_emails: ccEmails });
        setSaving(false);
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content enm-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Edit Notifications</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit} className="modal-body">
                    <p className="enm-box-name">{box.name}</p>

                    <div className="form-group">
                        <label className="form-label">Email frequency</label>
                        <select
                            className="enm-select"
                            value={emailFrequency}
                            onChange={(e) => setEmailFrequency(e.target.value)}
                        >
                            {FREQUENCY_OPTIONS.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        <p className="enm-hint">{FREQUENCY_HINTS[emailFrequency]}</p>
                    </div>

                    <div className="form-group">
                        <CcEmailsInput
                            value={ccEmails}
                            onChange={setCcEmails}
                            inputClassName="enm-input"
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn-primary" disabled={saving}>
                            {saving ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body
    );
};

export default EditNotificationsModal;
